import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Config } from "src/app/config";
import { Subject } from "rxjs";
import { ServiceOptions } from "../models/service-options";
import { Popup } from "../models/popup";
import { ServiceMetaData } from "../models/service-meta.model";
import { RouteEnum } from "../models/routes.model";
import moment from "moment";
import { RXTooth } from "../models/order.model";
import * as CryptoJS from "crypto-js";
import {
  RELOAD_INBOX,
  SELECT_INBOX_ORDER,
  UI__ROUTE_NAVIGATION,
  UI__SIDEBAR_ROUTE_NAVIGATION,
  NAVIGATE_TO_NEXT_ORDER_PAGE,
} from "../ngrx/ngrx-actions";
import {
  orders,
  currentOrder,
  inboxNeedsReload,
  orderNavNextSw,
  nextOrderOnSamePage,
  qcModeSw,
} from "../ngrx/ngrx-selectors";

// custom enhancements

declare global {
  interface Array<T> {
    loading: boolean;
    sorry: boolean;
    srp_shuffle: Function;
    srp_merge: Function;
    srp_allTrue: Function;
    srp_someTrue: Function;
    srp_sortByKey: Function;
    serviceMetaData: ServiceMetaData;
  }
  interface Date {
    to_DD_MM_YYYY: Function;
    to_DD_MM_YYYY_HH_MM: Function;
    to_HH_MM_SS: Function;
    srp_getWeekNumber: Function;
    srp_addDays: Function;
    srp_today: Function;
    srp_todayTs: Function;
  }
  interface String {
    DD_MM_YYYY_toTime: any;
    SRP_trimWord: Function;
  }
}

Array.prototype.loading = false;
Array.prototype.sorry = false;
Array.prototype.serviceMetaData;
Array.prototype.srp_shuffle = function () {
  let randomIndex: number, i: number, arrayItemStore: any;
  for (i = this.length - 1; i > 0; i--) {
    randomIndex = Math.floor(Math.random() * (i + 1));
    arrayItemStore = this[i];
    this[i] = this[randomIndex];
    this[randomIndex] = arrayItemStore;
  }
  return this;
};
Array.prototype.srp_merge = function (filterBy?: string) {
  const ar = this;
  const map = new Map();
  let i = -1;
  const l = ar.length - 1;

  if (filterBy) {
    while (i++ < l) map.set(ar[i][filterBy], ar[i]);
  } else {
    while (i++ < l) map.set(JSON.stringify(ar[i]), ar[i]);
  }

  return [...(map.values() as any)];
};

Array.prototype.srp_allTrue = function () {
  return this.length && this.reduce((a, b) => !!a && !!b);
};
Array.prototype.srp_someTrue = function () {
  return this.length && this.reduce((a, b) => !!a || !!b);
};
Array.prototype.srp_sortByKey = function (
  key: string,
  desc: boolean = false,
  customRule?: (string: string) => any
) {
  return this.sort((a, b) => {
    let _a, _b;
    if (typeof customRule === "function") {
      _a = customRule(a[key]);
      _b = customRule(b[key]);
    } else {
      _a = typeof a[key] === "string" ? a[key].toLowerCase() : a[key];
      _b = typeof b[key] === "string" ? b[key].toLowerCase() : b[key];
    }

    const returnIfSmaller = desc ? 1 : -1;
    const returnIfBigger = desc ? -1 : 1;

    if (_a < _b) {
      return returnIfSmaller;
    } else {
      return returnIfBigger;
    }
  });
};

Date.prototype.to_DD_MM_YYYY = function (shortYear?: boolean) {
  let dd = this.getDate(),
    mm = this.getMonth() + 1, //January is 0!
    yyyy = this.getFullYear().toString(),
    ddStr: string = dd.toString(),
    mmStr: string = mm.toString();

  if (dd < 10) {
    ddStr = "0" + dd;
  }
  if (mm < 10) {
    mmStr = "0" + mm;
  }
  if (shortYear) {
    yyyy = yyyy.slice(-2);
  }
  return ddStr + "/" + mmStr + "/" + yyyy; //format("DD/MM/YYYY")
};

Date.prototype.to_DD_MM_YYYY_HH_MM = function () {
  let year = this.to_DD_MM_YYYY(),
    hour = this.getHours(),
    minutes = this.getMinutes();
  if (hour < 10) {
    hour = "0" + hour;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  return year + " " + hour + ":" + minutes;
};
Date.prototype.to_HH_MM_SS = function () {
  let hour = this.getHours(),
    minutes = this.getMinutes(),
    seconds = this.getSeconds();
  if (hour < 10) {
    hour = "0" + hour;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  return `${hour}:${minutes}:${seconds.toString()}`;
};

Date.prototype.srp_getWeekNumber = function () {
  const d: any = new Date(
    Date.UTC(this.getFullYear(), this.getMonth(), this.getDate())
  );
  const firstDayOfWeek: 0 | 7 = 0;
  const dayNum = d.getUTCDay() || firstDayOfWeek;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  var yearStart: any = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
};

Date.prototype.srp_addDays = function (days: number) {
  const updated: Date = this.setDate(this.getDate() + days);
  return new Date(updated);
};
Date.prototype.srp_today = function () {
  const date = this.getDate();
  const month = this.getMonth();
  const year = this.getFullYear();
  return new Date(year, month, date);
};
Date.prototype.srp_todayTs = function () {
  return this.srp_today().getTime();
};

String.prototype.DD_MM_YYYY_toTime = function () {
  let timeArr = this.split("/").map((item) => {
    return parseInt(item);
  });
  if (timeArr[2] < 2000) {
    timeArr[2] += 2000;
  }
  return new Date(timeArr[2], timeArr[1] - 1, timeArr[0]).getTime();
};
String.prototype.SRP_trimWord = function (by: number) {
  let _by: number = by && typeof by === "number" ? by : 10;
  if (this.length >= _by) {
    return this.substring(0, _by).trim() + "...";
  } else {
    return this;
  }
};

@Injectable({
  providedIn: "root",
})
export class SharedService {
  overwriteUserLang: string;
  route: string;
  activeTab: string;
  appDateFormat: string = "dd/MM/yy HH:mm";
  routeEnum: RouteEnum = new RouteEnum();
  capturedUserPassword: string;
  static ui_lang: string;

  //config params
  static attachmentSubFolder: string;
  static attachmentFileTypes: string;
  static bannerSubFolder: string;
  static filesBucketUrl: string;
  static uploadBucketUrl: string;
  static teethDef: RXTooth[] = [];
  stageColors: [];

  static calLocale = {
    firstDayOfWeek: 0,
    dayNames: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
    dayNamesShort: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
    dayNamesMin: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
    monthNames: [
      "ינואר",
      "פברואר",
      "מרץ",
      "אפריל",
      "מאי",
      "יוני",
      "יולי",
      "אוגוסט",
      "ספטמבר",
      "אוקטובר",
      "נובמבר",
      "דצמבר",
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    today: "היום",
    clear: "נקה",
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    private store: Store
  ) {
    this.cookiesGen();

    SharedService.attachmentFileTypes =
      Config.assetConfigData["attachmentFileTypes"];
    SharedService.attachmentSubFolder =
      Config.assetConfigData["attachmentSubFolder"];
    SharedService.bannerSubFolder = Config.assetConfigData["bannerSubFolder"];
    SharedService.filesBucketUrl = Config.assetConfigData["filesBucketUrl"];
    SharedService.uploadBucketUrl = Config.assetConfigData["uploadBucketUrl"];

    this.stageColors = Config.assetConfigData["stageColors"];

    this.http.get<any>("assets/config/teeth.json").subscribe({
      next: (data) => {
        if (data && data["teeth"]) {
          data["teeth"].forEach((e) => {
            let t = new RXTooth(e.id, e.sortOrder, e.jaw);
            SharedService.teethDef.push(t);
          });
        } else {
          console.error('No teeth data found in response');
        }
      },
      error: (error) => {
        console.error('Error loading teeth.json:', error);
      }
    });
  }

  computeStyle(el: HTMLElement, style: string, toInt: boolean) {
    if (!el) return;
    if (toInt) {
      return parseInt(
        window.getComputedStyle(el, null).getPropertyValue(style)
      );
    } else {
      return window.getComputedStyle(el, null).getPropertyValue(style);
    }
  }

  // --- cookies ---

  encryptionKey: string = "DS4545SDSDV3#$gfg545667#$#$erer#$#$DFF";
  cookies = {};
  cookiesGen() {
    let cookie: any = document.cookie;
    if (!cookie) return "";
    cookie = cookie.split("; ");
    this.cookies = {};
    cookie = cookie.forEach((item) => {
      item = item.split("=");
      this.cookies[item[0]] = item[1];
    });
  }

  getCookie(key: string, secure: boolean = false) {
    let value = this.cookies[key] || "";
    if (secure) {
      let decrypted = CryptoJS.AES.decrypt(value, this.encryptionKey);
      var plaintext = decrypted.toString(CryptoJS.enc.Utf8);

      return plaintext;
    } else {
      return value;
    }
  }

  putCookie(key: string, value: string, secure: boolean = false) {
    let exp = new Date();
    exp.setDate(exp.getDate() + 30);
    this.removeCookie(key);

    let set = key + "=" + value;
    if (secure) {
      let encrypted = CryptoJS.AES.encrypt(value, this.encryptionKey);
      document.cookie =
        key + "=" + encrypted.toString() + ";expires=" + exp.toString();
    } else {
      document.cookie = set + ";expires=" + exp.toString();
    }
  }

  removeCookie(key: string) {
    document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT;";
  }

  // events

  popup = new Subject<Popup>();
  popup$ = this.popup.asObservable();
  emitPopupchReceivedEvent(popup: Popup) {
    this.popup.next(popup);
  }

  //menu hide /reveal
  private menuBtnClicked = new Subject<boolean>();
  menuBtnClicked$ = this.menuBtnClicked.asObservable();
  emitMenuBtnClickedEvent(cond: boolean) {
    this.menuBtnClicked.next(cond);
  }

  private isSidebarOpen = new Subject<boolean>();
  isSidebarOpen$ = this.isSidebarOpen.asObservable();
  emitIsSidebarOpenEvent(cond: boolean) {
    this.isSidebarOpen.next(cond);
  }

  // alerts

  alertError(
    message: any,
    title: string = "",
    subtitle: string = "",
    serviceName?: string
  ) {
    let service = serviceName ? " | Called by " + serviceName : "";
    this.emitPopupchReceivedEvent({
      title: title || "translate.alert.wrongTitle",
      subTitle: subtitle || "translate.alert.wrongSubTitle",
      message: message,
      icon: "exclamation-triangle",
    });
  }

  alertSuccess(message: string, title: string = "") {
    this.emitPopupchReceivedEvent({
      title: title,
      subTitle: [message],
      icon: "check",
    });
  }

  alertWarning(err: string) {
    this.emitPopupchReceivedEvent({
      subTitle: err,
    });
  }

  alertInfo(msg: string) {
    this.emitPopupchReceivedEvent({
      title: "translate.alert.infoTitle",
      subTitle: msg,
    });
  }

  alertMsg(title: string, msg: string) {
    this.emitPopupchReceivedEvent({
      title: title,
      subTitle: msg,
    });
  }

  // loading
  private generalLoader = new Subject<boolean>();
  generalLoader$ = this.generalLoader.asObservable();
  emitGeneralLoaderEvent(cond: boolean) {
    this.generalLoader.next(cond);
  }

  isMobile() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne( (c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor);
    return check;
  }

  formatDate(date: Date) {
    return moment(date).format("DD/MM/YY");
  }

  getTeethValidityCode(teeth: string) {
    if (!teeth) return [0, 0];

    // delimited list of "iso3950 teeth"
    const baseValidity =
      /^\s*(?:(?:[1-4][1-8]|[5-8][1-5])[,\-]\s*)*(?:(?:[1-4][1-8]|[5-8][1-5]))$/gm;
    if (!baseValidity.test(teeth)) {
      return [1, 0]; // invalid input string
    }

    teeth = teeth.split(" ").join(""); // drop spaces
    const splints = teeth.split(",");

    const iso3950ToOrdinalJawMap: { [key: string]: number[] } = {
      "11": [8, 1],
      "12": [7, 1],
      "13": [6, 1],
      "14": [5, 1],
      "15": [4, 1],
      "16": [3, 1],
      "17": [2, 1],
      "18": [1, 1],
      "21": [9, 1],
      "22": [10, 1],
      "23": [11, 1],
      "24": [12, 1],
      "25": [13, 1],
      "26": [14, 1],
      "27": [15, 1],
      "28": [16, 1],
      "31": [25, 2],
      "32": [26, 2],
      "33": [27, 2],
      "34": [28, 2],
      "35": [29, 2],
      "36": [30, 2],
      "37": [31, 2],
      "38": [32, 2],
      "41": [24, 2],
      "42": [23, 2],
      "43": [22, 2],
      "44": [21, 2],
      "45": [20, 2],
      "46": [19, 2],
      "47": [18, 2],
      "48": [17, 2],
      "51": [48, 3],
      "52": [47, 3],
      "53": [46, 3],
      "54": [45, 3],
      "55": [44, 3],
      "56": [43, 3],
      "57": [42, 3],
      "58": [41, 3],
      "61": [49, 3],
      "62": [50, 3],
      "63": [51, 3],
      "64": [52, 3],
      "65": [53, 3],
      "66": [54, 3],
      "67": [55, 3],
      "68": [56, 3],
      "71": [65, 4],
      "72": [66, 4],
      "73": [67, 4],
      "74": [68, 4],
      "75": [69, 4],
      "76": [70, 4],
      "77": [71, 4],
      "78": [72, 4],
      "81": [64, 4],
      "82": [63, 4],
      "83": [62, 4],
      "84": [61, 4],
      "85": [60, 4],
      "86": [59, 4],
      "87": [58, 4],
      "88": [57, 4],
    };

    let lineTeethOrdinals: number[] = [];
    let firstTooth;
    let secondTooth;
    let firstJaw: number;
    let secondJaw: number;
    let splint: string;
    let ord: number;

    let cnt: number = 0;

    for (let i = 0; i < splints.length; i++) {
      splint = splints[i];
      if (splint.includes("-")) {
        [firstTooth, secondTooth] = splint.split("-");

        [firstTooth, firstJaw] = iso3950ToOrdinalJawMap[firstTooth];
        [secondTooth, secondJaw] = iso3950ToOrdinalJawMap[secondTooth];

        if (firstJaw != secondJaw) {
          return [3, 0]; // the splint crosses different jaws
        }

        if (firstTooth == secondTooth) {
          return [2, 0]; // teeth are overlapping between splints
        }

        for (
          ord = Math.min(firstTooth, secondTooth);
          ord <= Math.max(firstTooth, secondTooth);
          ord++
        ) {
          if (lineTeethOrdinals.includes(ord)) {
            return [2, 0]; // teeth are overlapping between splints
          }
          lineTeethOrdinals.push(ord);
          cnt++;
        }
      } else {
        ord = iso3950ToOrdinalJawMap[splint][0];
        if (lineTeethOrdinals.includes(ord)) {
          return [2, 0]; // teeth are overlapping between splints
        }
        lineTeethOrdinals.push(ord);
        cnt++;
      }
    }

    return [0, cnt];
  }

  goToInbox(focusOrderIdInput: boolean = false) {
    this.store.dispatch(
      SELECT_INBOX_ORDER({
        order: null,
      })
    );

    this.store.dispatch(
      UI__ROUTE_NAVIGATION({
        data: { link: this.routeEnum.URL_INBOX_VIEW },
      })
    );

    this.store.dispatch(
      UI__SIDEBAR_ROUTE_NAVIGATION({
        data: { tabId: "inbox" },
      })
    );

    const queryParams = focusOrderIdInput ? { focusOrderId: 'true' } : {};
    this.router.navigate([this.routeEnum.URL_INBOX], { queryParams });

    if (this.store.selectSignal(inboxNeedsReload)()) {
      this.store.dispatch(RELOAD_INBOX());
    }
  }

  goToNextOrder() {
    const ordersList = this.store.selectSignal(orders)();
    const current = this.store.selectSignal(currentOrder)();
    const hasNextOrder = this.store.selectSignal(orderNavNextSw)();
    const nextOnSamePage = this.store.selectSignal(nextOrderOnSamePage)();

    if (!hasNextOrder || !ordersList || !current) {
      const qcMode = this.store.selectSignal(qcModeSw)();
      this.goToInbox(qcMode);
      return;
    }

    // If there's a next order in current page, select it
    if (nextOnSamePage) {
      let curIdx = ordersList.findIndex(
        (o) => o.orderId == current?.orderId
      );
      if (curIdx != -1 && curIdx < ordersList.length - 1) {
        let order = ordersList[curIdx + 1];
        this.store.dispatch(
          SELECT_INBOX_ORDER({
            order: order,
          })
        );
      }
    } else {
      // We're on last order of current page, need to load next page
      this.store.dispatch(NAVIGATE_TO_NEXT_ORDER_PAGE());
    }
  }
}
